export default {
  title: 'Paramètres',
  drawer: {
    account: 'Compte',
    billing: 'Facturation et utilisation',
    developer: 'Développeur',
    dangerZone: 'Supprimer le compte',
    notifications: 'Notifications',
    myProfile: 'Mon profil',
    personalSettings: 'Paramètres personnels',
    myOrganization: 'Mon organisation',
    organizationDetails: 'Détail de l\'organisation',
    subscriptionBilling: 'Forfait & factures',
    team: 'Équipe',
    consumption: 'Consommation',
    helpSupport: 'Aide & support',
    supportRequests: 'Demandes d\'assistance',
    helpCenter: 'Centre d\'aide',
    apiAccess: 'Accès API',
    advancedSettings: 'Paramètres avancés'
  },
  deleteAccount: {
    title: 'Supprimer le compte',
    subtitle: 'Supprimer définitivement votre compte et toutes les données associées',
    steps: {
      warning: 'Conséquences',
      feedback: 'Commentaires',
      confirm: 'Confirmation'
    },
    warning: {
      title: 'Cette action est permanente et ne peut pas être annulée',
      item1: 'Toutes vos données personnelles seront définitivement supprimées',
      item2: 'Vous perdrez l\'accès à tous vos fichiers, chaînes et vitrines',
      item3: 'Tous vos abonnements actifs seront annulés',
      item4: 'Vous serez immédiatement déconnecté de tous les appareils',
      understand: 'Je comprends que cette action est irréversible',
      organizationsTitle: 'Les organisations dont vous êtes propriétaire seront supprimées',
      organizationsDescription: 'Vous êtes propriétaire des organisations suivantes. Ces organisations et toutes leurs données seront définitivement supprimées.',
      organizationMembers: '{count} membres',
      organizationTransferHint: 'Pour conserver ces organisations, transférez la propriété à un autre membre avant de supprimer votre compte.'
    },
    feedback: {
      title: 'Aidez-nous à nous améliorer',
      subtitle: 'Nous sommes désolés de vous voir partir. Vos commentaires nous aident à améliorer notre service.',
      additional: 'Commentaires supplémentaires (facultatif)',
      placeholder: 'Dites-nous en plus sur votre expérience...'
    },
    reasons: {
      noLongerNeeded: 'Je n\'ai plus besoin du service',
      foundAlternative: 'J\'ai trouvé une meilleure alternative',
      tooExpensive: 'Le service est trop cher',
      privacyConcerns: 'J\'ai des préoccupations concernant la confidentialité',
      difficultToUse: 'Le service est trop difficile à utiliser',
      notEnoughFeatures: 'Pas assez de fonctionnalités pour mes besoins',
      other: 'Autre raison'
    },
    otp: {
      title: 'Vérifiez votre identité',
      subtitle: 'Nous avons envoyé un code de vérification à {email}',
      resend: 'Renvoyer le code',
      resendIn: 'Renvoyer le code dans {seconds}s',
      confirmLabel: 'Tapez le texte de confirmation',
      confirmPlaceholder: 'Tapez ici',
      confirmHint: 'Tapez "{text}" pour confirmer la suppression du compte',
      deleteButton: 'Supprimer définitivement mon compte',
      error: 'Code de vérification invalide. Veuillez réessayer.'
    }
  },
  sections: {
    profile: 'Profil',
    appearance: 'Apparence',
    security: 'Sécurité',
    billing: 'Facturation',
    usage: 'Statistiques d\'utilisation',
    api: 'Clés API'
  },
  profile: {
    title: 'Profil',
    subtitle: 'Gérez vos informations personnelles et les paramètres de votre compte',
    avatar: {
      title: 'Photo de profil',
      upload: 'Télécharger une photo',
      remove: 'Supprimer la photo',
      hint: 'JPG, PNG ou GIF. Max 5 Mo.'
    },
    personal: {
      title: 'Informations personnelles',
      firstName: 'Prénom',
      lastName: 'Nom',
      username: 'Nom d\'utilisateur'
    },
    emails: {
      title: 'Adresses email',
      add: 'Ajouter un email',
      primary: 'Principal',
      unverified: 'Non vérifiée',
      makePrimary: 'Définir comme principal',
      resendVerification: 'Renvoyer la vérification',
      remove: 'Supprimer'
    },
    language: {
      title: 'Préférence de langue',
      select: 'Sélectionner la langue',
      hint: 'Choisissez votre langue préférée pour l\'interface'
    },
    password: {
      title: 'Mot de passe',
      lastChanged: 'Dernière modification {date}',
      change: 'Modifier le mot de passe',
      current: 'Mot de passe actuel',
      new: 'Nouveau mot de passe',
      confirm: 'Confirmer le nouveau mot de passe',
      update: 'Mettre à jour le mot de passe'
    },
    twoFactor: {
      title: 'Authentification à deux facteurs',
      notEnabled: 'L\'authentification à deux facteurs ajoute une couche de sécurité supplémentaire à votre compte.',
      enabled: 'L\'authentification à deux facteurs est activée',
      enable: 'Activer l\'authentification à deux facteurs',
      disable: 'Désactiver',
      manage: 'Gérer les méthodes',
      methods: 'Méthodes actives'
    },
    danger: {
      title: 'Zone dangereuse',
      description: 'Supprimer définitivement votre compte et tout son contenu.',
      deleteAccount: 'Supprimer le compte'
    }
  },
  appearance: {
    title: 'Paramètres d\'apparence',
    theme: 'Thème',
    themeDescription: 'Choisissez votre thème de couleur préféré',
    language: 'Langue',
    languageDescription: 'Choisissez votre langue préférée',
    dateFormat: 'Format de date',
    timeFormat: 'Format d\'heure'
  },
  security: {
    title: 'Paramètres de sécurité',
    password: 'Mot de passe',
    changePassword: 'Changer le mot de passe',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    twoFactor: 'Authentification à deux facteurs',
    enable2FA: 'Activer 2FA',
    disable2FA: 'Désactiver 2FA',
    sessions: 'Sessions actives',
    logoutAll: 'Déconnecter toutes les sessions'
  },
  billing: {
    title: 'Facturation et abonnement',
    subtitle: 'Gérez votre abonnement, vos méthodes de paiement et vos factures',
    subscription: {
      title: 'Abonnement actuel',
      currentPlan: 'Plan actuel',
      nextBilling: 'Prochaine facturation le {date} • {amount}',
      paymentMethod: 'Méthode de paiement se terminant par {method}',
      perMonth: 'par mois',
      cancel: 'Annuler l\'abonnement',
      status: {
        active: 'Actif',
        cancelled: 'Annulé',
        past_due: 'En retard'
      }
    },
    packs: {
      title: 'Packs d\'utilisation',
      add: 'Ajouter un pack',
      perPack: 'pack',
      upgrade: 'Augmenter'
    },
    payment: {
      title: 'Méthodes de paiement',
      add: 'Ajouter une méthode de paiement',
      expires: 'Expire le {date}',
      default: 'Par défaut',
      makeDefault: 'Définir par défaut',
      remove: 'Supprimer'
    },
    address: {
      title: 'Adresse de facturation',
      company: 'Entreprise (facultatif)',
      firstName: 'Prénom',
      lastName: 'Nom',
      street: 'Adresse',
      zipCode: 'Code postal',
      city: 'Ville',
      country: 'Pays',
      taxId: 'Numéro de TVA / SIRET',
      taxIdHint: 'Pour les entreprises UE : numéro de TVA pour l\'exonération fiscale'
    },
    invoices: {
      title: 'Factures',
      number: 'Numéro de facture',
      date: 'Date',
      description: 'Description',
      amount: 'Montant',
      status: {
        paid: 'Payée',
        pending: 'En attente',
        overdue: 'En retard'
      }
    },
    cancelDialog: {
      title: 'Annuler l\'abonnement',
      warning: 'Votre abonnement restera actif jusqu\'à la fin de la période de facturation en cours.',
      description: 'Après l\'annulation, vous perdrez l\'accès à toutes les fonctionnalités premium. Vos données seront conservées pendant 30 jours.',
      reason: 'Raison de l\'annulation (facultatif)',
      confirm: 'Annuler l\'abonnement'
    },
    freeTier: {
      planName: 'Plan Gratuit',
      planDescription: 'Parfait pour démarrer avec les fonctionnalités de base',
      forever: 'Gratuit à vie',
      upgradeToPro: 'Passer au Pro',
      upgradeNow: 'Passer au Pro - {price}/mois',
      quotas: {
        title: 'Quotas d\'utilisation',
        included: 'Inclus dans le plan gratuit',
        nearLimit: 'Proche de la limite',
        upgradeInfo: 'Besoin de plus de ressources ? Passez au Pro pour une utilisation illimitée'
      },
      benefits: {
        title: 'Comparer les plans',
        currentPlan: 'Plan Gratuit',
        proPlan: 'Plan Professionnel'
      },
      features: {
        storage5gb: '5 Go de stockage',
        bandwidth10gb: '10 Go de bande passante par mois',
        user1: '1 utilisateur',
        basicSupport: 'Support communautaire',
        publicShowcases: 'Vitrines publiques uniquement',
        unlimitedStorage: 'Packs de stockage personnalisables',
        unlimitedBandwidth: 'Packs de bande passante personnalisables',
        unlimitedUsers: 'Packs multi-utilisateurs',
        prioritySupport: 'Support email prioritaire',
        privateShowcases: 'Vitrines privées et protégées par mot de passe',
        advancedAnalytics: 'Analyses avancées et statistiques',
        apiAccess: 'Accès API pour intégrations',
        customBranding: 'Options de personnalisation'
      },
      payment: {
        noMethod: 'Aucune méthode de paiement',
        noMethodDescription: 'Ajoutez une méthode de paiement pour passer au Pro'
      },
      invoices: {
        noInvoices: 'Aucune facture pour le moment',
        noInvoicesDescription: 'Les factures apparaîtront ici lorsque vous passerez à un plan payant'
      },
      upgradeDialog: {
        title: 'Passer au Professionnel',
        noPaymentMethod: 'Vous devrez ajouter une méthode de paiement pour finaliser la mise à niveau',
        addPaymentAndUpgrade: 'Ajouter un moyen de paiement et passer au Pro',
        benefit1Title: 'Évoluez sans limites',
        benefit1Description: 'Ajoutez du stockage, de la bande passante et des utilisateurs selon vos besoins',
        benefit2Title: 'Fonctionnalités avancées',
        benefit2Description: 'Débloquez les analyses, l\'accès API et le support premium',
        benefit3Title: 'Sécurité renforcée',
        benefit3Description: 'Vitrines privées et contrôles d\'accès avancés'
      }
    }
  },
  api: {
    title: 'Clés API',
    description: 'Gérez vos clés API pour les intégrations externes',
    createKey: 'Créer une nouvelle clé',
    keyName: 'Nom de la clé',
    permissions: 'Permissions',
    created: 'Créée',
    lastUsed: 'Dernière utilisation',
    revoke: 'Révoquer',
    copyKey: 'Copier la clé',
    keyWarning: 'Assurez-vous de copier votre clé API maintenant. Vous ne pourrez plus la voir après !'
  },
  usage: {
    title: 'Statistiques d\'utilisation',
    subtitle: 'Surveillez votre consommation de ressources et votre activité',
    export: 'Exporter les données',
    billingCycle: 'Cycle de facturation',
    storage: 'Stockage',
    bandwidth: 'Bande passante',
    users: 'Utilisateurs',
    totalStorage: 'Stockage total',
    totalBandwidth: 'Bande passante totale',
    activeUsers: 'Utilisateurs actifs',
    projectedCost: 'Coût projeté',
    of: 'sur {total}',
    thisMonth: 'ce mois-ci',
    upgrade: 'Augmenter',
    downloads: 'Téléchargements',
    uploads: 'Téléversements',
    peakDay: 'Jour de pointe',
    averageDaily: 'Moyenne quotidienne',
    recentActivity: 'Activité récente',
    viewAll: 'Voir tout',
    justNow: 'À l\'instant',
    hoursAgo: 'Il y a {hours}h',
    daysAgo: 'Il y a {days}j',
    projectionWarning: 'Selon l\'utilisation actuelle, vous pourriez atteindre {value} d\'ici la fin du mois',
    periods: {
      week: '7 derniers jours',
      month: 'Ce mois-ci',
      '3months': '3 derniers mois',
      '6months': '6 derniers mois',
      year: 'Cette année'
    },
    charts: {
      trend: 'Tendance d\'utilisation',
      breakdown: 'Répartition du stockage'
    },
    monthlyHistory: {
      storage: 'Historique du stockage',
      bandwidth: 'Historique de la bande passante',
      month: 'Mois',
      usage: 'Utilisation',
      limit: 'Limite',
      change: 'Variation',
      additionalCost: 'Coût suppl.',
      total: 'Total',
      breakdown: 'Down/Up',
      peak: 'Jour de pointe'
    }
  }
}
